import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/members/password"
class ChangePassword extends Component {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            wrongPassword: "",
            data: {
                currentPassword: "",
                password: "",
                passwordRepeat: ""
            },
            errors: {},
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()
        if (this.state.data.password !== this.state.data.passwordRepeat) {
            this.setState({ errors: { ...this.state.errors, 'passwordRepeat': "Password and password repeat have to match" } })
            return false;
        } else {
            this.setState({ errors: { ...this.state.errors, 'passwordRepeat': "" } })
        }
        // TODO: Post this.state.data to the API
        Api.print("Sending json...")

        Api.PostApi(FETCH_URL, this.state.data, this.props.history)
            .then(data => {
                if (data !== undefined) {
                    if (data === "Incorrect password.") {
                        this.setState({ wrongPassword: <p style={{ color: 'red' }}>Incorrect wachtwoord.</p> })
                    } else {
                        if (data === "Passwords must be at least 6 characters.") {
                            this.setState({ wrongPassword: <p style={{ color: 'red' }}>Wachtwoorden moeten minimaal 6 tekens bevatten.</p> })
                        }
                        else {
                            if (data === "Passwords must have at least one non alphanumeric character.") {
                                this.setState({ wrongPassword: <p style={{ color: 'red' }}>Wachtwoorden moeten ten minste één niet-alfanumeriek teken hebben.</p> })
                            }
                            else {
                                if (data === "Passwords must have at least one uppercase ('A'-'Z').") {
                                    this.setState({ wrongPassword: <p style={{ color: 'red' }}>Wachtwoorden moeten ten minste één hoofdletter hebben ('A'-'Z').</p> })
                                }
                                else {
                                    if (data === "Passwords must have at least one digit ('0'-'9').") {
                                        this.setState({ wrongPassword: <p style={{ color: 'red' }}>Wachtwoorden moeten ten minste één cijfer hebben ('0'-'9').</p> })
                                    }
                                    else {
                                        this.setState({ wrongPassword: "" })
                                        this.setState({ errors: data });
                                    }
                                }
                            }
                        }
                    }

                } else {
                    alert("Password updated")
                    window.location.href = '/account/beheren/'
                }
            })
    }

    render() {
        let data = this.state.data
        let errors = this.state.errors
        return (
            <div>
                <h5>Account gegevens</h5>
                <Form horizontal onSubmit={this.handleSubmit}>
                    <FormGroup controlId="PasswordEmail">
                        <Col componentClass={ControlLabel} sm={4}>
                            E-mail
                    </Col>
                        <Col sm={6}>
                            <div>
                                {Api.getMail()} &nbsp;&nbsp;<i><small>(email adres wijzigen alleen via het secretariaat)</small></i>
                            </div>
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="PasswordHuidig">
                        <Col componentClass={ControlLabel} sm={4}>
                            Huidig wachtwoord
                    </Col>
                        <Col sm={6}>
                            <FormControl type="password" name="currentPassword" value={data.currentPassword} onChange={this.handleChange} />
                            {Api.showError(errors, "currentPassword")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="PasswordNieuw">
                        <Col componentClass={ControlLabel} sm={4}>
                            Nieuw wachtwoord
                    </Col>
                        <Col sm={6}>
                            <FormControl type="password" name="password" value={data.password} onChange={this.handleChange} />
                            {Api.showError(errors, "password")}
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="PasswordNieuwRepeat">
                        <Col componentClass={ControlLabel} sm={4}>
                            Bevestig wachtwoord
                    </Col>
                        <Col sm={6}>
                            <FormControl type="password" name="passwordRepeat" value={data.passwordRepeat} onChange={this.handleChange} />
                            {Api.showError(errors, "passwordRepeat")}
                        </Col>
                    </FormGroup>
                    <Row>
                        <Col sm={4} className="text-left">
                            <LinkContainer to="/account/beheren">
                                <Button type="button" name="cancelButton">Annuleren</Button>
                            </LinkContainer>
                        </Col>
                        <Col sm={6} className="text-right">
                            {this.state.wrongPassword}
                            <Button type="submit" name="submitButton">Opslaan</Button>
                        </Col>
                    </Row>



                </Form>
            </div>
        );
    }
}

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Account/WachtwoordWijzigen.js